import React, { useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import '../../assets/styles/dateRange.scss';
import AddButtonSection from './AddButtonSection';

export default function DateRange({
  date,
  cancel = () => {},
  setDate,
  className = "customCare-dateRange",
}) {
  const [rangeDate, setRangeDate] = React.useState([{}]);

  const submitButtons = [
    {
      type: "secondaryButton",
      label: "Cancel",
      class: "w-7rem",
      onClick: () => {
        cancel();
      },
    },
    {
      type: "primarySuccessButton",
      label: "Ok",
      class: "w-6rem pl-3",
      onClick: () => {
        setDate(rangeDate);
      },
    },
  ];

  useEffect(() => {
    if (date) {
      setRangeDate(date);
    }
  }, [date]);

  return (
    <div className="customCare-dateRange">
      <DateRangePicker
        onChange={(item) => setRangeDate([item.selection])}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={window.innerWidth < 640 ? 1 : 2}
        ranges={rangeDate}
        className={`${className} w-full`}
        direction={window.innerWidth < 640 ? "vertical" : "horizontal"}
      />

      <div className="flex justify-end p-4 sm:p-6">
        <AddButtonSection buttons={submitButtons} />
      </div>
    </div>
  );
}
